import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n6 = 0, F = function F() {}; return { s: F, n: function n() { return _n6 >= r.length ? { done: !0 } : { done: !1, value: r[_n6++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as e } from "../utils/isPlainObject.js";
import { isString as t } from "../utils/isString.js";
import { isNode as n } from "../utils/isNode.js";
import { stringToHtml as o } from "../utils/strToHtml.js";
import { getScrollableParent as i } from "../utils/getScrollableParent.js";
import { scrollLock as l } from "../utils/scrollLock.js";
import { extend as s } from "../utils/extend.js";
import { canUseDOM as r } from "../utils/canUseDOM.js";
import { map as a } from "../utils/map.js";
import { addClass as c } from "../utils/addClass.js";
import { PANZOOM_DEFAULT_POS as u } from "../panzoom/panzoom.js";
export { Panzoom, PanzoomAction, PanzoomZoomLevel } from "../panzoom/panzoom.js";
import { Carousel as d } from "../carousel/carousel.js";
import { Zoomable as f } from "../carousel/carousel.zoomable.js";
import { Sync as m } from "../carousel/carousel.sync.js";
import { Lazyload as p } from "../carousel/carousel.lazyload.js";
import { Arrows as g } from "../carousel/carousel.arrows.js";
import { Toolbar as v } from "../carousel/carousel.toolbar.js";
export { ToolbarColumn } from "../carousel/carousel.toolbar.js";
import { Autoplay as y } from "../carousel/carousel.autoplay.js";
import { Thumbs as h } from "../carousel/carousel.thumbs.js";
import { Html as b } from "../carousel/carousel.html.js";
import { Video as E } from "../carousel/carousel.video.js";
import { Fullscreen as x } from "../carousel/carousel.fullscreen.js";
import { Hash as w } from "./fancybox.hash.js";
import { Tween as L } from "../libs/tween.js";
import { en_EN as j } from "./l10n/en_EN.js";
import { Gestures as P } from "../libs/gestures.js";
import { removeClass as S } from "../utils/removeClass.js";
import { toggleClass as C } from "../utils/toggleClass.js";
var T = '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>';
v().add("close", {
  tpl: T
});
var A = function A(e) {
    e && e.dispatchEvent(new CustomEvent("animationend", {
      bubbles: !1,
      cancelable: !0,
      currentTarget: e
    }));
  },
  M = function M() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var n = arguments.length > 2 ? arguments[2] : undefined;
    if (!e || !e.parentElement || !t) return void (n && n());
    A(e);
    var _o = function o(i) {
      i.target === e && e.dataset.animationName && (e.removeEventListener("animationend", _o), delete e.dataset.animationName, n && n(), e.classList.remove(t));
    };
    e.dataset.animationName = t, e.addEventListener("animationend", _o), c(e, t);
  };
var k;
!function (e) {
  e[e.Init = 0] = "Init", e[e.Ready = 1] = "Ready", e[e.Closing = 2] = "Closing", e[e.Destroyed = 3] = "Destroyed";
}(k || (k = {}));
var _ = {
    ajax: null,
    backdropClick: "close",
    Carousel: {},
    closeButton: "auto",
    closeExisting: !1,
    delegateEl: void 0,
    dragToClose: !0,
    fadeEffect: !0,
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    id: void 0,
    idle: !1,
    keyboard: {
      Escape: "close",
      Delete: "close",
      Backspace: "close",
      PageUp: "next",
      PageDown: "prev",
      ArrowUp: "prev",
      ArrowDown: "next",
      ArrowRight: "next",
      ArrowLeft: "prev"
    },
    l10n: j,
    mainClass: "",
    mainStyle: {},
    mainTpl: '<dialog class="fancybox__dialog">\n    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">\n      <div class="fancybox__backdrop"></div>\n      <div class="fancybox__carousel"></div>\n    </div>\n  </dialog>',
    on: {},
    parentEl: void 0,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    sync: void 0,
    theme: "dark",
    triggerEl: void 0,
    triggerEvent: void 0,
    zoomEffect: !0
  },
  O = new Map();
var D = 0;
var R = "with-fancybox",
  I = function I() {
    var r,
      w,
      j,
      I,
      z,
      B = k.Init,
      N = Object.assign({}, _),
      q = -1,
      V = {},
      F = [],
      W = !1,
      $ = !0,
      K = 0;
    function U(e) {
      var n = N[e];
      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }
      return n && "function" == typeof n ? n.apply(void 0, [Se].concat(t)) : n;
    }
    function X(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var n = U("l10n") || {};
      e = String(e).replace(/\{\{(\w+)\}\}/g, function (e, t) {
        return n[t] || e;
      });
      for (var _n = 0; _n < t.length; _n++) e = e.split(t[_n][0]).join(t[_n][1]);
      return e = e.replace(/\{\{(.*?)\}\}/g, function (e, t) {
        return t;
      });
    }
    var G = new Map();
    function Y(e) {
      var n = _toConsumableArray(G.get(e) || []);
      for (var _i = 0, _Object$entries = Object.entries(N.on || {}); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          _t = _Object$entries$_i[0],
          _o2 = _Object$entries$_i[1];
        (_t === e || _t.split(" ").indexOf(e) > -1) && n.push(_o2);
      }
      for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        t[_key2 - 1] = arguments[_key2];
      }
      var _iterator = _createForOfIteratorHelper(n),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          _e && "function" == typeof _e && _e.apply(void 0, [Se].concat(t));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      "*" !== e && Y.apply(void 0, ["*", e].concat(t));
    }
    function Z() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      B !== k.Init && (Se.destroy(), B = k.Init), N = s({}, _, n), q = U("id") || "fancybox-" + ++D;
      var a = O.get(q);
      if (a && a.destroy(), O.set(q, Se), Y("init"), function () {
        for (var _i2 = 0, _Object$entries2 = Object.entries(Object.assign(Object.assign({}, H.Plugins), N.plugins || {})); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            _e2 = _Object$entries2$_i[0],
            _t2 = _Object$entries2$_i[1];
          if (_e2 && !V[_e2] && _t2 instanceof Function) {
            var _n2 = _t2();
            _n2.init(Se), V[_e2] = _n2;
          }
        }
        Y("initPlugins");
      }(), function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        Y("initSlides", e), F = _toConsumableArray(e);
      }(t), function () {
        var t = U("parentEl") || document.body;
        if (!(t && t instanceof HTMLElement)) return;
        var n = X(U("mainTpl") || "");
        if (r = o(n) || void 0, !r) return;
        if (w = r.querySelector(".fancybox__container"), !(w && w instanceof HTMLElement)) return;
        var s = U("mainClass");
        s && c(w, s);
        var a = U("mainStyle");
        if (a && e(a)) for (var _i3 = 0, _Object$entries3 = Object.entries(a); _i3 < _Object$entries3.length; _i3++) {
          var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
            _e3 = _Object$entries3$_i[0],
            _t3 = _Object$entries3$_i[1];
          w.style.setProperty(_e3, _t3);
        }
        var u = U("theme"),
          d = "auto" === u ? window.matchMedia("(prefers-color-scheme:light)").matches : "light" === u;
        w.setAttribute("theme", d ? "light" : "dark"), r.setAttribute("id", "".concat(q)), r.addEventListener("keydown", function (e) {
          "Escape" === e.key && e.preventDefault();
        }), r.addEventListener("wheel", function (e) {
          var t = e.target;
          var n = U("wheel", e);
          t.closest(".f-thumbs") && (n = "slide");
          var o = "slide" === n,
            l = [-e.deltaX || 0, -e.deltaY || 0, -e.detail || 0].reduce(function (e, t) {
              return Math.abs(t) > Math.abs(e) ? t : e;
            }),
            s = Math.max(-1, Math.min(1, l)),
            r = Date.now();
          K && r - K < 300 ? o && e.preventDefault() : (K = r, Y("wheel", e, s), e.defaultPrevented || ("close" === n ? Le(e) : "slide" === n && I && !i(t) && (e.preventDefault(), I[s > 0 ? "prev" : "next"]())));
        }, {
          capture: !0,
          passive: !1
        }), r.addEventListener("cancel", function (e) {
          Le(e);
        }), t.append(r), 1 === O.size && (U("hideScrollbar") && l(!0), document.documentElement.classList.add(R));
        r instanceof HTMLDialogElement && r.showModal();
        Y("initLayout");
      }(), function () {
        if (j = (null == r ? void 0 : r.querySelector(".fancybox__carousel")) || void 0, !j) return;
        j.fancybox = Se;
        var e = s({}, {
          Autoplay: {
            autoStart: !1,
            pauseOnHover: !1,
            progressbarParentEl: function progressbarParentEl(e) {
              var t = e.getContainer();
              return (null == t ? void 0 : t.querySelector(".f-carousel__toolbar [data-autoplay-action]")) || t;
            }
          },
          Fullscreen: {
            el: w
          },
          Toolbar: {
            absolute: !0,
            items: {
              counter: {
                tpl: '<div class="f-counter"><span data-fancybox-page></span>/<span data-fancybox-pages></span></div>'
              }
            },
            display: {
              left: ["counter"],
              right: ["toggleFull", "autoplay", "fullscreen", "thumbs", "close"]
            }
          },
          Video: {
            autoplay: !0
          },
          Thumbs: {
            minCount: 2,
            Carousel: {
              classes: {
                container: "fancybox__thumbs"
              }
            }
          },
          classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            slide: "fancybox__slide"
          },
          spinnerTpl: '<div class="f-spinner" data-fancybox-close></div>',
          dragFree: !1,
          slidesPerPage: 1,
          plugins: {
            Sync: m,
            Arrows: g,
            Lazyload: p,
            Zoomable: f,
            Html: b,
            Video: E,
            Autoplay: y,
            Fullscreen: x,
            Thumbs: h,
            Toolbar: v
          }
        }, U("Carousel") || {}, {
          slides: F,
          enabled: !0,
          initialPage: U("startIndex") || 0,
          l10n: U("l10n")
        });
        I = d(j, e), Y("initCarousel", I), I.on("*", function (e, t) {
          for (var _len3 = arguments.length, n = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            n[_key3 - 2] = arguments[_key3];
          }
          Y.apply(void 0, ["Carousel.".concat(t), e].concat(n));
        }), I.on("attachSlideEl", Q), I.on("detachSlideEl", ee), I.on("contentReady", le), I.on("ready", oe), I.on("change", ne), I.on("settle", ie), I.on("thumbs:ready", se), I.on("thumbs:destroy", se), I.init();
      }(), r && w) {
        if (U("closeExisting")) {
          var _iterator2 = _createForOfIteratorHelper(O.entries()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                _e4 = _step2$value[0],
                _t4 = _step2$value[1];
              _e4 !== q && _t4.close();
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        U("fadeEffect") ? (setTimeout(function () {
          J();
        }, 500), c(w, "is-revealing")) : J(), w.classList.add("is-ready"), B = k.Ready, Y("ready");
      }
    }
    function J() {
      S(w, "is-revealing");
      try {
        if (document.activeElement === r) {
          ((null == w ? void 0 : w.querySelector("[autofocus]")) || w).focus();
        }
      } catch (e) {}
    }
    function Q(e, n) {
      var o;
      fe(n), re(), null === (o = n.el) || void 0 === o || o.addEventListener("click", te), "inline" !== n.type && "clone" !== n.type || function (e) {
        if (!I || !e || !e.el) return;
        var n = null;
        if (t(e.src)) {
          var _t5 = e.src.split("#", 2).pop();
          n = _t5 ? document.getElementById(_t5) : null;
        }
        if (n) {
          if (c(n, "f-html"), "clone" === e.type || n.closest(".fancybox__carousel")) {
            n = n.cloneNode(!0);
            var _t6 = n.dataset.animationName;
            _t6 && (n.classList.remove(_t6), delete n.dataset.animationName);
            var _o3 = n.getAttribute("id");
            _o3 = _o3 ? "".concat(_o3, "--clone") : "clone-".concat(q, "-").concat(e.index), n.setAttribute("id", _o3);
          } else if (n.parentNode) {
            var _t7 = document.createElement("div");
            _t7.inert = !0, n.parentNode.insertBefore(_t7, n), e.placeholderEl = _t7;
          }
          e.htmlEl = n, c(e.el, "has-html"), e.el.prepend(n), n.classList.remove("hidden"), "none" === n.style.display && (n.style.display = ""), "none" === getComputedStyle(n).getPropertyValue("display") && (n.style.display = n.dataset.display || "flex"), null == I || I.emit("contentReady", e);
        } else null == I || I.showError(e, "{{ELEMENT_NOT_FOUND}}");
      }(n), "ajax" === n.type && function (e) {
        var t = e.el;
        if (!t) return;
        if (e.htmlEl || e.xhr) return;
        null == I || I.showLoading(e), e.state = 0;
        var n = new XMLHttpRequest();
        n.onreadystatechange = function () {
          if (n.readyState === XMLHttpRequest.DONE && B === k.Ready) if (null == I || I.hideLoading(e), e.state = 1, 200 === n.status) {
            var _o4 = n.responseText + "",
              _i4 = null,
              _l = null;
            if (e.filter) {
              var _t8 = document.createElement("div");
              _t8.innerHTML = _o4, _l = _t8.querySelector(e.filter + "");
            }
            _l && _l instanceof HTMLElement ? _i4 = _l : (_i4 = document.createElement("div"), _i4.innerHTML = _o4), _i4.classList.add("f-html"), e.htmlEl = _i4, t.classList.add("has-html"), t.classList.add("has-ajax"), t.prepend(_i4), null == I || I.emit("contentReady", e);
          } else null == I || I.showError(e);
        };
        var o = U("ajax") || null;
        n.open(o ? "POST" : "GET", e.src + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(o), e.xhr = n;
      }(n);
    }
    function ee(e, t) {
      var n;
      !function (e) {
        e.closeButtonEl && (e.closeButtonEl.remove(), e.closeButtonEl = void 0);
      }(t), null === (n = t.el) || void 0 === n || n.removeEventListener("click", te), "inline" !== t.type && "clone" !== t.type || function (e) {
        var t = e.htmlEl,
          n = e.placeholderEl;
        t && ("none" !== getComputedStyle(t).getPropertyValue("display") && (t.style.display = "none"), t.offsetHeight);
        n && (t && n.parentNode && n.parentNode.insertBefore(t, n), n.remove());
        e.htmlEl = void 0, e.placeholderEl = void 0;
      }(t), t.xhr && (t.xhr.abort(), t.xhr = void 0);
    }
    function te(e) {
      if (!pe()) return;
      if (B !== k.Ready) return e.preventDefault(), void e.stopPropagation();
      if (e.defaultPrevented) return;
      if (!P.isClickAllowed()) return;
      var t = e.composedPath()[0];
      t.closest(".fancybox__carousel") && t.classList.contains("fancybox__slide") && ae(e);
    }
    function ne() {
      $ = !1, w && I && w.classList.remove("is-revealing"), re();
      var e = U("sync");
      if (I && e) {
        var _t9 = e.getPageIndex(I.getPageIndex()) || 0;
        e.goTo(_t9, {
          transition: !1
        });
      }
    }
    function oe() {
      var e;
      if (B !== k.Ready) return;
      me(ge()), function () {
        if (!U("dragToClose")) return;
        if (!I) return;
        var e = I.getViewport();
        if (!e) return;
        var t = P(e).init();
        if (!t) return;
        var n = 0,
          o = 0,
          l = L().on("step", function (e) {
            n = e.y;
            var t = null == I ? void 0 : I.getViewport();
            if (w && t) {
              var _e5 = a(Math.abs(n), 0, .5 * t.getBoundingClientRect().height, 1, .5);
              w.style.setProperty("--f-drag-opacity", _e5 + ""), w.style.setProperty("--f-drag-offset", n + "px");
            }
          }).on("end", function () {
            if (!n) {
              w && w.style.removeProperty("--f-opacity");
              var _e6 = null == I ? void 0 : I.getViewport();
              _e6 && (_e6.style.transform = "");
            }
          });
        t.on("start", function () {
          l.pause();
        }).on("panstart", function (e) {
          var t;
          var n = e.srcEvent.target;
          n && !i(n) && (null === (t = null == I ? void 0 : I.getViewport()) || void 0 === t || t.classList.add("is-dragging"));
        }).on("pan", function (e) {
          var t = e.srcEvent.target;
          if (t && i(t)) return;
          (null == I ? void 0 : I.getViewport()) && "y" === e.axis && (o += e.deltaY, l.spring({
            clamp: !0,
            mass: 1,
            tension: 860,
            friction: 17,
            restDelta: .01,
            restSpeed: .01
          }).from({
            y: n
          }).to({
            y: o
          }).start());
        }).on("end", function (e) {
          l.pause(), "y" === e.axis && Math.abs(e.velocityY) > 5 && Math.abs(o) > 0 && (Le(e.srcEvent, "f-throwOut" + (e.velocityY > 0 ? "Down" : "Up")), B === k.Closing) || 0 !== o && (o = 0, l.spring({
            clamp: !0,
            mass: 1,
            tension: 140,
            friction: 25,
            restDelta: .1,
            restSpeed: .1,
            maxSpeed: 1 / 0
          }).from({
            y: n
          }).to({
            y: o
          }).start());
        });
      }(), document.body.addEventListener("click", de), document.body.addEventListener("keydown", ue, {
        passive: !1,
        capture: !0
      }), re(), be();
      var t = U("sync");
      t && (null === (e = t.getTween()) || void 0 === e || e.start());
    }
    function ie() {
      (null == I ? void 0 : I.canGoNext()) ? be() : we();
    }
    function le(e, t) {
      fe(t), me(t);
    }
    function se() {
      var e;
      var t = null == I ? void 0 : I.getPlugins().Thumbs;
      C(w, "has-thumbs", (null == t ? void 0 : t.isEnabled()) || !1), C(w, "has-vertical-thumbs", (null === (e = null == t ? void 0 : t.getCarousel()) || void 0 === e ? void 0 : e.isVertical()) || !1);
    }
    function re() {
      if (w) {
        var _e7 = (null == I ? void 0 : I.getPages()) || [],
          _t10 = (null == I ? void 0 : I.getPageIndex()) || 0;
        var _iterator3 = _createForOfIteratorHelper(w.querySelectorAll("[data-fancybox-index]")),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _e8 = _step3.value;
            _e8.innerHTML = _t10 + "";
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        var _iterator4 = _createForOfIteratorHelper(w.querySelectorAll("[data-fancybox-page]")),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _e9 = _step4.value;
            _e9.innerHTML = _t10 + 1 + "";
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        var _iterator5 = _createForOfIteratorHelper(w.querySelectorAll("[data-fancybox-pages]")),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _t11 = _step5.value;
            _t11.innerHTML = _e7.length + "";
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    }
    function ae(e) {
      if (!!e.composedPath()[0].closest("[data-fancybox-close]")) return void Le(e);
      if (Y("backdropClick", e), e.defaultPrevented) return;
      U("backdropClick") && Le(e);
    }
    function ce() {
      xe();
    }
    function ue(e) {
      if (!pe()) return;
      if (B !== k.Ready) return;
      var t = e.key,
        o = U("keyboard");
      if (!o) return;
      if (e.ctrlKey || e.altKey || e.shiftKey) return;
      var i = e.composedPath()[0];
      if (!n(i)) return;
      if ("Escape" !== t && function (e) {
        var t = ["input", "textarea", "select", "option", "video", "iframe", "[contenteditable]", "[data-selectable]", "[data-draggable]"].join(",");
        return e.matches(t) || e.closest(t);
      }(i)) return;
      if (Y("keydown", e), e.defaultPrevented) return;
      var l = o[t];
      if (l) switch (l) {
        case "close":
          Le(e);
          break;
        case "next":
          e.preventDefault(), null == I || I.next();
          break;
        case "prev":
          e.preventDefault(), null == I || I.prev();
      }
    }
    function de(e) {
      if (!pe()) return;
      if (B !== k.Ready) return;
      if (xe(), e.defaultPrevented) return;
      var t = e.composedPath()[0],
        n = !!t.closest("[data-fancybox-close]"),
        o = t.classList.contains("fancybox__backdrop");
      (n || o) && ae(e);
    }
    function fe(e) {
      var t;
      var n = e.el,
        i = e.htmlEl,
        l = e.closeButtonEl;
      if (!n || !i || l) return;
      var s = U("closeButton");
      if ("auto" === s && (s = !0 !== (null === (t = null == I ? void 0 : I.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled())), s) {
        var _t12 = o(X(T));
        _t12 && (e.closeButtonEl = i.insertAdjacentElement("afterbegin", _t12), n.classList.add("has-close-btn"));
      }
    }
    function me(e) {
      if (!($ && I && 1 === I.getState() && e && e.index === I.getOptions().initialPage && e.el && e.el.parentElement)) return;
      if (void 0 !== e.state && 1 !== e.state) return;
      $ = !1;
      var t = e.panzoomRef,
        n = null == t ? void 0 : t.getTween(),
        o = U("zoomEffect") && n ? ye(e) : void 0;
      if (t && n && o) {
        var _t$getStartPosition = t.getStartPosition(),
          _e10 = _t$getStartPosition.x,
          _i5 = _t$getStartPosition.y,
          _l2 = _t$getStartPosition.scale;
        return void n.spring({
          tension: 225,
          friction: 25,
          restDelta: .001,
          restSpeed: .001,
          maxSpeed: 1 / 0
        }).from(o).to({
          x: _e10,
          y: _i5,
          scale: _l2
        }).start();
      }
      var i = (null == t ? void 0 : t.getContent()) || e.htmlEl;
      i && M(i, U("showClass", e));
    }
    function pe() {
      var e;
      return (null === (e = H.getInstance()) || void 0 === e ? void 0 : e.getId()) === q;
    }
    function ge() {
      var e;
      return null === (e = null == I ? void 0 : I.getPage()) || void 0 === e ? void 0 : e.slides[0];
    }
    function ve() {
      var e = ge();
      return e ? e.triggerEl || U("triggerEl") : void 0;
    }
    function ye(e) {
      var t, n;
      var o = e.thumbEl;
      if (!o || !function (e) {
        var t = e.getBoundingClientRect(),
          n = e.closest("[style]"),
          o = null == n ? void 0 : n.parentElement;
        if (n && n.style.transform && o) {
          var _e11 = o.getBoundingClientRect();
          if (t.left < _e11.left || t.left > _e11.left + _e11.width - t.width) return !1;
          if (t.top < _e11.top || t.top > _e11.top + _e11.height - t.height) return !1;
        }
        var i = Math.max(document.documentElement.clientHeight, window.innerHeight),
          l = Math.max(document.documentElement.clientWidth, window.innerWidth);
        return !(t.bottom < 0 || t.top - i >= 0 || t.right < 0 || t.left - l >= 0);
      }(o)) return;
      var i = null === (n = null === (t = e.panzoomRef) || void 0 === t ? void 0 : t.getWrapper()) || void 0 === n ? void 0 : n.getBoundingClientRect(),
        l = null == i ? void 0 : i.width,
        s = null == i ? void 0 : i.height;
      if (!l || !s) return;
      var r = o.getBoundingClientRect();
      var a = r.width,
        c = r.height,
        u = r.left,
        d = r.top;
      if (!r || !a || !c) return;
      if (o instanceof HTMLImageElement) {
        var _e12 = window.getComputedStyle(o).getPropertyValue("object-fit");
        if ("contain" === _e12 || "scale-down" === _e12) {
          var _ref = function (e, t, n, o) {
              var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "contain";
              if ("contain" === i || e > n || t > o) {
                var _i6 = n / e,
                  _l3 = o / t,
                  _s = Math.min(_i6, _l3);
                e *= _s, t *= _s;
              }
              return {
                width: e,
                height: t
              };
            }(o.naturalWidth, o.naturalHeight, a, c, _e12),
            _t13 = _ref.width,
            _n3 = _ref.height;
          u += .5 * (a - _t13), d += .5 * (c - _n3), a = _t13, c = _n3;
        }
      }
      if (Math.abs(l / s - a / c) > .1) return;
      return {
        x: u + .5 * a - (i.left + .5 * l),
        y: d + .5 * c - (i.top + .5 * s),
        scale: a / l
      };
    }
    function he() {
      z && clearTimeout(z), z = void 0, document.removeEventListener("mousemove", ce);
    }
    function be() {
      if (W) return;
      if (z) return;
      var e = U("idle");
      e && (z = setTimeout(Ee, e));
    }
    function Ee() {
      w && (he(), c(w, "is-idle"), document.addEventListener("mousemove", ce), W = !0);
    }
    function xe() {
      W && (we(), be());
    }
    function we() {
      he(), null == w || w.classList.remove("is-idle"), W = !1;
    }
    function Le(e, t) {
      var n, o, i, l, r, a;
      if (B === k.Closing || B === k.Destroyed) return;
      var c = new Event("shouldClose", {
        bubbles: !0,
        cancelable: !0
      });
      if (Y("shouldClose", c, e), c.defaultPrevented) return;
      if (he(), e) {
        if (e.defaultPrevented) return;
        e.cancelable && e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
      }
      if (B = k.Closing, I) {
        null === (n = I.getGestures()) || void 0 === n || n.destroy(), null === (o = I.getTween()) || void 0 === o || o.pause();
        var _e13 = ge(),
          _t14 = null == _e13 ? void 0 : _e13.panzoomRef;
        _e13 && _t14 && s(_t14.getOptions(), {
          clickAction: !1,
          wheelAction: !1,
          bounds: !1,
          minScale: 0,
          maxScale: 1 / 0
        });
        var _iterator6 = _createForOfIteratorHelper(I.getSlides()),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _e14 = _step6.value;
            null === (l = null === (i = _e14.panzoomRef) || void 0 === i ? void 0 : i.getGestures()) || void 0 === l || l.destroy(), null === (a = null === (r = _e14.panzoomRef) || void 0 === r ? void 0 : r.getTween()) || void 0 === a || a.pause();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
      var u = null == I ? void 0 : I.getPlugins().fullscreen;
      u && u.inFullscreen() ? Promise.resolve(u.exit()).then(function () {
        setTimeout(function () {
          je(e, t);
        }, 150);
      }) : je(e, t);
    }
    function je(e, t) {
      var n, o, i, l, s;
      if (B !== k.Closing) return;
      if (Y("close", e), U("placeFocusBack")) {
        var _e15 = ve();
        !_e15 || (s = _e15.getBoundingClientRect()).bottom > 0 && s.right > 0 && s.left < (window.innerWidth || document.documentElement.clientWidth) && s.top < (window.innerHeight || document.documentElement.clientHeight) || _e15.scrollIntoView({
          behavior: "instant",
          block: "center",
          inline: "center"
        });
      }
      U("fadeEffect") && (null == w || w.classList.remove("is-ready"), null == w || w.classList.add("is-hiding")), null == w || w.classList.add("is-closing");
      var r = ge(),
        a = null == r ? void 0 : r.panzoomRef,
        c = null === (n = null == r ? void 0 : r.panzoomRef) || void 0 === n ? void 0 : n.getTween(),
        d = t || U("hideClass");
      var f = !1,
        m = !1;
      if (I && r && a && c) {
        var _e16;
        U("zoomEffect") && ((null === (i = null === (o = I.getTween()) || void 0 === o ? void 0 : o.getCurrentVelocities()) || void 0 === i ? void 0 : i.pos) || 0) < 700 && 1 === r.state && (_e16 = ye(r)), _e16 && (f = !0, I.on("refresh", function () {
          var e = ye(r);
          e && c.to(Object.assign(Object.assign({}, u), e));
        }), c.easing(L.Easings.EaseOut).duration(350).from(Object.assign({}, a.getTransform())).to(Object.assign(Object.assign({}, u), _e16)).start());
      }
      var p = (null == r ? void 0 : r.htmlEl) || (null === (l = null == r ? void 0 : r.panzoomRef) || void 0 === l ? void 0 : l.getWrapper());
      p && A(p), !f && d && p && (m = !0, M(p, d, function () {
        Pe();
      })), f || m ? setTimeout(function () {
        Pe();
      }, 350) : Pe();
    }
    function Pe() {
      var e, t, n, o, i, s;
      if (B === k.Destroyed) return;
      B = k.Destroyed, document.body.removeEventListener("click", de), document.body.removeEventListener("keydown", ue, {
        passive: !1,
        capture: !0
      });
      var a = ve();
      Y("destroy"), null === (t = null === (e = U("sync")) || void 0 === e ? void 0 : e.getPlugins().Autoplay) || void 0 === t || t.resume(), null === (o = null === (n = U("sync")) || void 0 === n ? void 0 : n.getPlugins().Autoscroll) || void 0 === o || o.resume(), r instanceof HTMLDialogElement && r.close(), null === (i = null == I ? void 0 : I.getContainer()) || void 0 === i || i.classList.remove("is-idle"), null == I || I.destroy();
      for (var _i7 = 0, _Object$values = Object.values(V); _i7 < _Object$values.length; _i7++) {
        var _e17 = _Object$values[_i7];
        null == _e17 || _e17.destroy();
      }
      if (V = {}, null == r || r.remove(), r = void 0, w = void 0, I = void 0, O.delete(q), !O.size) if (l(!1), document.documentElement.classList.remove(R), U("placeFocusBack")) try {
        null == a || a.focus({
          preventScroll: !0
        });
      } catch (e) {} else null === (s = document.activeElement) || void 0 === s || s.blur();
    }
    var Se = {
      close: Le,
      destroy: Pe,
      getCarousel: function getCarousel() {
        return I;
      },
      getContainer: function getContainer() {
        return w;
      },
      getId: function getId() {
        return q;
      },
      getOptions: function getOptions() {
        return N;
      },
      getPlugins: function getPlugins() {
        return V;
      },
      getSlide: function getSlide() {
        return ge();
      },
      getState: function getState() {
        return B;
      },
      init: function init() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Z(e, t), Se;
      },
      isCurrentSlide: function isCurrentSlide(e) {
        var t = ge();
        return !(!e || !t) && t.index === e.index;
      },
      isTopMost: function isTopMost() {
        return pe();
      },
      off: function off(e, t) {
        return G.has(e) && G.set(e, G.get(e).filter(function (e) {
          return e !== t;
        })), Se;
      },
      on: function on(e, t) {
        return G.set(e, [].concat(_toConsumableArray(G.get(e) || []), [t])), Se;
      },
      toggleIdle: function toggleIdle(e) {
        (W || !0 === e) && Ee(), W && !1 !== e || we();
      }
    };
    return Se;
  };
var H = {
  Plugins: {
    Hash: w
  },
  version: "6.0.29",
  openers: new Map(),
  bind: function bind(e, n, o) {
    if (!r()) return;
    var i = document.body,
      l = "[data-fancybox]",
      s = {};
    if (t(e) ? (i = document.body, l = e, "object" == typeof n && (s = n || {})) : e instanceof Element && (i = e, t(n) && (l = n), "object" == typeof o && (s = o || {})), !(i && i instanceof Element && l)) return !1;
    var a = H.openers.get(i) || new Map();
    if (a.set(l, s), H.openers.set(i, a), 1 === a.size) {
      i.addEventListener("click", H.fromEvent);
      for (var _i8 = 0, _Object$values2 = Object.values(H.Plugins); _i8 < _Object$values2.length; _i8++) {
        var _e18 = _Object$values2[_i8];
        var _t15 = _e18.setup;
        "function" == typeof _t15 && _t15(H);
      }
    }
    return !0;
  },
  close: function close() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
    for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      t[_key4 - 1] = arguments[_key4];
    }
    if (e) {
      var _iterator7 = _createForOfIteratorHelper(O.values()),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _e19 = _step7.value;
          _e19.close.apply(_e19, t);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    } else {
      var _e20 = H.getInstance();
      _e20 && _e20.close.apply(_e20, t);
    }
  },
  destroy: function destroy() {
    var e;
    for (; e = H.getInstance();) e.destroy();
    var _iterator8 = _createForOfIteratorHelper(H.openers.keys()),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _e21 = _step8.value;
        _e21.removeEventListener("click", H.fromEvent);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    H.openers.clear();
  },
  fromEvent: function fromEvent(e) {
    var t, n, o;
    if (e.defaultPrevented) return;
    if (e.button && 0 !== e.button) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey) return;
    var i = e.composedPath()[0];
    if (i.closest(".fancybox__container.is-hiding")) return e.preventDefault(), void e.stopPropagation();
    var l = i.closest("[data-fancybox-delegate]") || void 0;
    if (l) {
      var _e22 = l.dataset.fancyboxDelegate || "",
        _t16 = document.querySelectorAll("[data-fancybox=\"".concat(_e22, "\"]"));
      i = _t16[parseInt(l.dataset.fancyboxIndex || "", 10) || 0] || _t16[0];
    }
    if (!(i && i instanceof Element)) return;
    var r,
      a,
      c = {};
    var _iterator9 = _createForOfIteratorHelper(H.openers),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _step9$value = _slicedToArray(_step9.value, 2),
          _e25 = _step9$value[0],
          _t18 = _step9$value[1];
        if (_t18 && _e25.contains(i)) {
          var _iterator11 = _createForOfIteratorHelper(_t18),
            _step11;
          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _step11$value = _slicedToArray(_step11.value, 2),
                _n5 = _step11$value[0],
                _o5 = _step11$value[1];
              var _t19 = null;
              try {
                _t19 = i.closest(_n5);
              } catch (e) {}
              _t19 && (i = _t19, r = _e25, a = _n5, s(c, _o5 || {}));
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
    if (!r || !a) return;
    e.preventDefault();
    var u = s({}, _, {
        triggerEvent: e,
        triggerEl: i,
        delegateEl: l
      }, c),
      d = u.groupAll,
      f = u.groupAttr,
      m = f && i ? i.getAttribute("".concat(f)) : "";
    var p = [];
    var g = null === (t = i.closest(".f-carousel")) || void 0 === t ? void 0 : t.carousel;
    if (g) {
      var _e23 = [];
      var _iterator10 = _createForOfIteratorHelper(null == g ? void 0 : g.getSlides()),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _t17 = _step10.value;
          var _n4 = _t17.el;
          _n4 && (_n4.matches(a) ? _e23.push(_n4) : _e23.push.apply(_e23, _toConsumableArray([].slice.call(_n4.querySelectorAll(a)))));
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      _e23.length && (p = [].concat(_e23), null === (n = g.getPlugins().Autoplay) || void 0 === n || n.pause(), null === (o = g.getPlugins().Autoscroll) || void 0 === o || o.pause(), u.sync = g);
    } else (!i || m || d) && (p = [].slice.call(r.querySelectorAll(a)));
    if (i && !d && (p = f && m ? p.filter(function (e) {
      return e.getAttribute("".concat(f)) === m;
    }) : [i]), !p.length) return;
    var v = H.getInstance();
    if (v) {
      var _e24 = v.getOptions().triggerEl;
      if (_e24 && p.indexOf(_e24) > -1) return;
    }
    return Object.assign({}, u.Carousel || {}).rtl && (p = p.reverse()), i && (u.startIndex = p.indexOf(i)), H.fromNodes(p, u);
  },
  fromNodes: function fromNodes(e, t) {
    t = s({}, _, t || {});
    var n = [],
      o = function o(e) {
        return e instanceof HTMLImageElement ? e : e instanceof HTMLElement ? e.querySelector("img:not([aria-hidden])") : void 0;
      };
    var _iterator12 = _createForOfIteratorHelper(e),
      _step12;
    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var _i9 = _step12.value;
        var _l4 = _i9.dataset || {},
          _s2 = t.delegateEl && e.indexOf(_i9) === t.startIndex ? t.delegateEl : void 0,
          _r = o(_s2) || o(_i9) || void 0,
          _a = _l4.src || _i9.getAttribute("href") || _i9.getAttribute("currentSrc") || _i9.getAttribute("src") || void 0,
          _c = _l4.thumb || _l4.thumbSrc || (null == _r ? void 0 : _r.getAttribute("currentSrc")) || (null == _r ? void 0 : _r.getAttribute("src")) || (null == _r ? void 0 : _r.dataset.lazySrc) || void 0,
          _u = {
            src: _a,
            alt: _l4.alt || (null == _r ? void 0 : _r.getAttribute("alt")) || void 0,
            thumbSrc: _c,
            thumbEl: _r,
            triggerEl: _i9,
            delegateEl: _s2
          };
        for (var _e26 in _l4) {
          var _t20 = _l4[_e26] + "";
          _t20 = "false" !== _t20 && ("true" === _t20 || _t20), _u[_e26] = _t20;
        }
        n.push(_u);
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
    return H.show(n, t);
  },
  fromSelector: function fromSelector(e, n, o) {
    var i = document.body,
      l = "",
      r = {};
    if (t(e) ? l = e : e instanceof Element && (i = e, t(n) && (l = n), "object" == typeof o && (r = o || {})), !(i && i instanceof Element && l)) return;
    var a = H.openers.get(i);
    return a ? (r = s({}, a.get(l) || {}, r), r ? H.fromNodes(Array.from(i.querySelectorAll(l)), r) : void 0) : void 0;
  },
  getCarousel: function getCarousel() {
    var e;
    return (null === (e = H.getInstance()) || void 0 === e ? void 0 : e.getCarousel()) || void 0;
  },
  getDefaults: function getDefaults() {
    return _;
  },
  getInstance: function getInstance(e) {
    if (e) {
      var _t21 = O.get(e);
      return _t21 && _t21.getState() !== k.Destroyed ? _t21 : void 0;
    }
    return Array.from(O.values()).reverse().find(function (e) {
      if (e.getState() !== k.Destroyed) return e;
    }) || void 0;
  },
  getSlide: function getSlide() {
    var e;
    return (null === (e = H.getInstance()) || void 0 === e ? void 0 : e.getSlide()) || void 0;
  },
  show: function show() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return I().init(e, t);
  },
  unbind: function unbind(e, n) {
    var o = document.body,
      i = "";
    if (t(e) ? i = e : e instanceof Element && (o = e, t(n) && (i = n)), o) {
      var _e27 = H.openers.get(o);
      _e27 && i && _e27.delete(i), (null == _e27 ? void 0 : _e27.size) && i || H.openers.delete(o), o.removeEventListener("click", H.fromEvent);
    }
  }
};
export { g as Arrows, y as Autoplay, d as Carousel, H as Fancybox, k as FancyboxState, x as Fullscreen, b as Html, p as Lazyload, u as PANZOOM_DEFAULT_POS, m as Sync, h as Thumbs, v as Toolbar, E as Video, f as Zoomable };